import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'no-permissions',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, RouterModule],
    templateUrl: './no-permissions.component.html',
})
export class NoPermissionsComponent {}
